import React from 'react';
import { AppFormInput } from '../../../components/common/appForms';
import type { CheckoutCardData } from '../checkout.types';
import { maskCheckoutCardField } from '../checkout.utils';
import pageStyles from '../CheckoutPage.module.css';
import styles from './CheckoutShared.module.css';

interface CreditCardFieldsProps {
  data: CheckoutCardData;
  errors: Record<string, string>;
  disabled?: boolean;
  onFieldChange: <K extends keyof CheckoutCardData>(
    field: K,
    value: CheckoutCardData[K],
  ) => void;
}

const CreditCardFields: React.FC<CreditCardFieldsProps> = ({
  data,
  errors,
  disabled = false,
  onFieldChange,
}) => {
  const handleMaskedChange = (field: keyof CheckoutCardData, rawValue: string) => {
    onFieldChange(field, maskCheckoutCardField(field, rawValue) as CheckoutCardData[typeof field]);
  };

  return (
    <div className={styles.creditCardFields}>
      <div style={{ marginTop: 5 }}></div>
      <AppFormInput
        id="checkout-card-holder-name"
        name="cardHolderName"
        label="Nome no cartão"
        value={data.holderName}
        onChange={(event) => onFieldChange('holderName', event.target.value)}
        placeholder="Como impresso no cartão"
        error={errors.cardHolderName}
        disabled={disabled}
        autoComplete="cc-name"
      />

      <AppFormInput
        id="checkout-card-number"
        name="cardNumber"
        label="Número do cartão"
        value={data.number}
        onChange={(event) => handleMaskedChange('number', event.target.value)}
        placeholder="0000 0000 0000 0000"
        inputMode="numeric"
        maxLength={19}
        error={errors.cardNumber}
        disabled={disabled}
        autoComplete="cc-number"
      />

      <div className={pageStyles.fieldRowHalf}>
        <AppFormInput
          id="checkout-card-expiry"
          name="cardExpiry"
          label="Validade"
          value={data.expiry}
          onChange={(event) => handleMaskedChange('expiry', event.target.value)}
          placeholder="MM/AA"
          inputMode="numeric"
          maxLength={5}
          error={errors.cardExpiry}
          disabled={disabled}
          autoComplete="cc-exp"
          containerClassName={pageStyles.fieldRowItem}
        />

        <AppFormInput
          id="checkout-card-cvv"
          name="cardCvv"
          label="CVV"
          value={data.cvv}
          onChange={(event) => handleMaskedChange('cvv', event.target.value)}
          placeholder="000"
          inputMode="numeric"
          maxLength={4}
          error={errors.cardCvv}
          disabled={disabled}
          autoComplete="cc-csc"
          containerClassName={pageStyles.fieldRowItem}
        />
      </div>
    </div>
  );
};

export default CreditCardFields;
